import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Eyebrow, Reveal } from "../site/motion";
import { NewsletterForm } from "../site/NewsletterForm";

export const StoryTeaser = () => (
  <section data-testid="story-teaser" className="mx-auto grid max-w-[1440px] gap-10 px-5 sm:px-8 lg:grid-cols-12 lg:px-12 py-20 sm:py-28 lg:py-36">
    <Reveal className="lg:col-span-5">
      <Eyebrow>The story</Eyebrow>
      <h2 className="mt-4 font-wide text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.92]">Our Story.</h2>
      <p className="mt-6 max-w-md text-base sm:text-lg text-dano-ink/80 leading-relaxed" data-testid="story-teaser-text">
        Dano Bars started in a place you'd never expect: at a poker table. Long casino nights, nothing real to eat, so Dany made his own. Soon the whole poker room knew him as Dano, the guy with the bars.
      </p>
      <Link to="/our-story" data-testid="story-teaser-link" className="group mt-8 inline-flex items-center gap-3 font-cond text-lg uppercase tracking-widest text-dano-red">
        <span className="link-underline">Read the story</span> <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
      </Link>
    </Reveal>
    <Reveal className="lg:col-span-7" delay={0.1}>
      <div className="relative aspect-[16/11] overflow-hidden rounded-[28px] spotlight-frame [clip-path:polygon(0_0,100%_6%,100%_100%,0_94%)]">
        <img src="/images/kitchen.jpg" alt="Bars being cut on a baking tray in a home kitchen" className="h-full w-full object-cover" />
      </div>
    </Reveal>
  </section>
);

export const SignupBlock = () => (
  <section data-testid="home-signup" className="px-5 sm:px-8 lg:px-12 pb-20 sm:pb-28">
    <Reveal>
      <div className="relative mx-auto max-w-[1440px] overflow-hidden rounded-[36px] bg-dano-red px-6 py-14 sm:px-12 sm:py-20 text-dano-cream">
        <svg viewBox="0 0 24 24" className="absolute -right-16 -top-16 h-72 w-72 text-dano-cream/10 animate-[spin_40s_linear_infinite]" aria-hidden="true">
          <path d="M12 0 L14.5 9.5 L24 12 L14.5 14.5 L12 24 L9.5 14.5 L0 12 L9.5 9.5 Z" fill="currentColor" />
        </svg>
        <div className="relative grid gap-10 lg:grid-cols-2 lg:items-end">
          <div>
            <p className="font-cond text-sm uppercase tracking-[0.22em] text-dano-cream/85">Launch list</p>
            <h2 className="mt-3 font-wide text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.9]">Get the first batch news.</h2>
            <p className="mt-4 max-w-md text-dano-cream/90">We'll email you when the recipe is final and bars are ready to order.</p>
          </div>
          <div className="[&_input]:text-dano-cream">
            <NewsletterForm source="home" tone="dark" id="newsletter" />
          </div>
        </div>
      </div>
    </Reveal>
  </section>
);
